export default __webpack_public_path__ + "static/media/check.2aa17dfa.png";